import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

import {
  IAPI_CON006_Request,
  IAPI_CON006_Response,
  IAPI_CON030_Request,
  IAPI_CON030_Response,
  IAPI_CON031_Request,
  IAPI_CON031_Response,
} from "../../../type/apiType";
import {
  IAPI_CON013_Request,
  IAPI_CON013_Response,
} from "../../../type/apiType";

// 社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届参照API
const httpAPI_CON006 = async (
  param: IAPI_CON006_Request
): Promise<IAPI_CON006_Response> => {
  let res = await http.post(ApiUrl.API_CON006, {
    ...param,
  });

  return res.data;
};

// 社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届更新API
const httpAPI_CON013 = async (
  param: IAPI_CON013_Request
): Promise<IAPI_CON013_Response> => {
  let res = await http.post(ApiUrl.API_CON013, {
    ...param,
  });

  return res.data;
};

// 日々更新法人職員系の退職年月日削除職員確認API
const httpAPI_CON031 = async (
  param: IAPI_CON031_Request
): Promise<IAPI_CON031_Response> => {
  const res = await http.post(ApiUrl.API_CON031, { ...param });
  return res.data;
};

// 日々更新法人職員系の退職年月日削除API
const httpAPI_CON030 = async (
  param: IAPI_CON030_Request
): Promise<IAPI_CON030_Response> => {
  const res = await http.post(ApiUrl.API_CON030, { ...param });
  return res.data;
};

export { httpAPI_CON006, httpAPI_CON013, httpAPI_CON031, httpAPI_CON030 };
